var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSingapore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_34115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37263 5.37262 0 12 0C18.6274 0 24 5.37263 24 12",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30451 6.26083C7.30451 4.51248 8.53324 3.05195 10.1741 2.69359C9.92187 2.63856 9.66026 2.6087 9.39143 2.6087C7.37435 2.6087 5.73926 4.2438 5.73926 6.26088C5.73926 8.27795 7.37435 9.91305 9.39143 9.91305C9.66016 9.91305 9.92182 9.88319 10.1741 9.82811C8.53324 9.46975 7.30451 8.00922 7.30451 6.26083Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0005 2.86957L12.2595 3.66668H13.0977L12.4195 4.15938L12.6786 4.95649L12.0005 4.46388L11.3224 4.95649L11.5814 4.15938L10.9033 3.66668H11.7414L12.0005 2.86957Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96737 4.43475L10.2264 5.23191H11.0645L10.3864 5.72457L10.6455 6.52168L9.96737 6.02907L9.28918 6.52168L9.54826 5.72457L8.87012 5.23191H9.70829L9.96737 4.43475Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0337 4.43475L14.2928 5.23191H15.1309L14.4527 5.72457L14.7118 6.52168L14.0337 6.02907L13.3556 6.52168L13.6146 5.72457L12.9365 5.23191H13.7746L14.0337 4.43475Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2505 6.78259L13.5095 7.57975H14.3476L13.6695 8.0724L13.9286 8.86951L13.2505 8.3769L12.5724 8.86951L12.8314 8.0724L12.1533 7.57975H12.9914L13.2505 6.78259Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7495 6.78259L11.0085 7.57975H11.8468L11.1686 8.0724L11.4277 8.86951L10.7495 8.3769L10.0714 8.86951L10.3304 8.0724L9.65234 7.57975H10.4905L10.7495 6.78259Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_34115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

export default __webpack_public_path__ + "media/8a746c1c.svg";
export { SvgSingapore as ReactComponent };